const errorCodesConfig = {
  errorCodes: {
    EMPTY_FIELD: "This field cannot be empty",
    INVALID_CREDENTIALS: "Invalid email or password",
    INVALID_OLD_PASSWORD: "Invalid old password",
    USER_DISABLED: "This account has been disabled",
    TOO_MANY_ATTEMPTS_TRY_LATER: "Too many attempts. Please try again later",
    PASSWORD_MISMATCH: "Passwords do not match",
    INVALID_EMAIL: "Invalid email",
    EMAIL_IN_USE: "Email already in use",
    EMAIL_BELONGS_TO_ARTIST: "This email is already associated with an artist",
    INVALID_PASSWORD_TOO_SHORT: "Password must contain 8-20 characters, with at least one number and one letter.",
    INVALID_PASSWORD_TOO_LONG: "Password must contain 8-20 characters, with at least one number and one letter.",
    INVALID_PASSWORD_NO_UPPERCASE: "Password must contain 8-20 characters, with at least one number and one letter.",
    INVALID_PASSWORD_NO_LOWERCASE: "Password must contain 8-20 characters, with at least one number and one letter.",
    INVALID_PASSWORD_NO_NUMBER: "Password must contain 8-20 characters, with at least one number and one letter.",
    INVALID_PASSWORD_NO_SPECIAL_CHARACTER: "Password must contain 8-20 characters, with at least one number and one letter.",
    TERMS_NOT_ACCEPTED: "You must accept the terms and conditions",
    QUALITY_PICTURES_NOT_ACCEPTED: "You must accept this condition",
    NOT_FOUND: "No profile associated with this email", 
    PROFILE_ALREADY_CLAIMED: "This profile has already been claimed",
    INVALID_CODE: "Invalid code", 
    INVALID_USERNAME_TOO_SHORT: "Username must be between 3 and 20 characters",
    INVALID_USERNAME_TOO_LONG: "Username must be between 3 and 20 characters",
    INVALID_USERNAME_NO_LETTER: "Username must contain at least one letter",
    INVALID_USERNAME_CHARACTER_NOT_ALLOWED: "Username must contain only letters, numbers and underscores",
    INVALID_USERNAME_ALREADY_IN_USE: "Username already in use",
    INVALID_USERNAME_TWO_UNDERSCORES_IN_A_ROW: "Username cannot contain two underscores in a row",
    INVALID_USERNAME: "Invalid username",
    USERNAME_EXPIRED_GALLERY: "You have already changed your username within the last 14 days. Try again in the near future",
    USERNAME_EXPIRED_ARTIST_COLLECTOR: "You have already changed your username within the last 12 months. Try again in the near future.",
    ONLY_ONE_FILE: "You can only upload one file",
    TOO_MANY_ARTWORK_IMAGES: "You can upload up to four secondary pictures of the artwork",
    FILE_EXCEEDS_SIZE: "File exceeds size limit (15 MB). Try uploading another",
    INVALID_FILE_FORMAT: "Invalid file format",
    MAIN_PICTURE_REQUIRED: "Main picture is required",
    SHIPPING_ERROR: "Invalid shipping details",
    INVALID_AGE: "You must be 18 years old or older to use this service",
    TITLE_TOO_SHORT: "Title must be at least 3 characters",
    DESCRIPTION_TOO_SHORT: "Description must be at least 10 characters",
    MEDIUM_TOO_SHORT: "Medium is too short",
    INVALID_SIZE: "Size must be any number greater than 0",
    INVALID_PRICE: "Price must be a whole number greater than 0",
    INVALID_PRICE_DOWNGRADE: "The artwork price cannot be set lower than 30% of its original upload price. If needed, reach out to us, and we’ll help adjust it.",
    INVALID_PRICE_LOWER_THAN_100: "The price of the artwork cannot be less than 100",
    ARTWORK_EDIT_IN_PROGRESS: "You have already submitted an artwork edit for this artwork. Wait until we accept those changes to request another edit of the artwork",
    ARTWORK_TERMS_NOT_ACCEPTED: "You must accept the artwork terms",
    ARRAY_EMPTY: "You must select at least one value",
    INVALID_OOB_CODE: "This link has expired. Please request a new password reset link.",
    INVALID_IBAN: "The entered IBAN is not valid. IBANs should contain only alphanumeric characters and have a valid country code and checksum. Please review and correct the IBAN.",
    INVALID_BIC: "The entered SWIFT/BIC is not valid. SWIFT/BIC codes should consist of 8 or 11 alphanumeric characters. Please double-check and try again.",
    MAX_ARTLISTS: "You are not allowed to create more than 3 artlists in your profile.",
    INVALID_ARTLIST_PERSONALIZED_TIME: "The minimum time lapse between artworks is 3 seconds.",
    RESERVED: "Another collector is currently trying to buy this artwork. Please try again later or choose a different item.",
    BUY_NOT_AVAILABLE: "The item that you are trying to buy is not available.",
    INVALID_CLAIM_CODE: "Invalid claim code",
    ISSUE_EVIDENCE_PHOTO: "Evidence is required"
  }
};

export default errorCodesConfig;